import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Palette, Trophy, Lightbulb, ArrowUpRight } from "lucide-react";
import { pillars } from "../mock/mock";
import { SectionHeading } from "./SectionHeading";

const icons = { GraduationCap, Palette, Trophy, Lightbulb };

export default function Pillars() {
  return (
    <section className="relative py-24 lg:py-32" style={{ background: "var(--cream)" }}>
      <div className="mx-auto max-w-[1280px] px-5 lg:px-6">
        <SectionHeading
          eyebrow="Academics"
          title="Empowering students with knowledge, innovation & research"
          sub="Four pillars hold up every KPR learner — a rigorous academic core, a rich co-curricular calendar, serious sport, and a habit of building things that did not exist before."
        />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {pillars.map((p, i) => {
            const Icon = icons[p.icon];
            return (
              <article
                key={p.no}
                data-reveal=""
                style={{ transitionDelay: `${i * 90}ms` }}
                className="group relative flex flex-col overflow-hidden rounded-2xl bg-white p-8"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow = "0 28px 60px -34px rgba(8,46,41,.45)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = "0 1px 0 rgba(8,46,41,.06)";
                }}
              >
                <span
                  className="absolute right-6 top-6 font-display text-[2.4rem] leading-none"
                  style={{ color: "rgba(11,59,54,.07)" }}
                >
                  {p.no}
                </span>

                <span
                  className="grid h-14 w-14 place-items-center rounded-xl"
                  style={{ background: "var(--teal-100)", color: "var(--teal-700)" }}
                >
                  <Icon size={24} strokeWidth={1.6} />
                </span>

                <h3
                  className="font-display mt-7 text-[1.4rem]"
                  style={{ color: "var(--teal-900)" }}
                >
                  {p.title}
                </h3>
                <p className="mt-4 flex-1 text-[0.9rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                  {p.text}
                </p>

                <Link
                  to="/academics"
                  className="mt-7 inline-flex items-center gap-2 text-[0.8rem] font-semibold"
                  style={{ color: "var(--gold)" }}
                >
                  Learn more
                  <ArrowUpRight size={15} className="group-hover:translate-x-1 group-hover:-translate-y-1" style={{ transition: "transform .3s ease" }} />
                </Link>

                <span
                  className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 group-hover:scale-x-100"
                  style={{ background: "var(--gold-400)", transition: "transform .45s cubic-bezier(.22,1,.36,1)" }}
                />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
